const STORAGE_KEY = 'dashboard-include-third-party';

export const readIncludeThirdParty = (): boolean => {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};

export const writeIncludeThirdParty = (included: boolean): void => {
    try {
        sessionStorage.setItem(STORAGE_KEY, String(included));
    } catch {
        // Storage refused. Remembering the tick is a nicety; the page works without it.
    }
};

export const clearIncludeThirdParty = (): void => {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // Storage refused, so nothing was stored to clear.
    }
};
